const Gallery = ({ color }: any) => {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M12.6667 2H3.33333C2.59695 2 2 2.59695 2 3.33333V12.6667C2 13.403 2.59695 14 3.33333 14H12.6667C13.403 14 14 13.403 14 12.6667V3.33333C14 2.59695 13.403 2 12.6667 2Z'
        stroke='white'
        strokeWidth='1.3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.66699 6.66602C6.21928 6.66602 6.66699 6.2183 6.66699 5.66602C6.66699 5.11373 6.21928 4.66602 5.66699 4.66602C5.11471 4.66602 4.66699 5.11373 4.66699 5.66602C4.66699 6.2183 5.11471 6.66602 5.66699 6.66602Z'
        stroke='white'
        strokeWidth='1.3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M13.9997 9.99935L10.6663 6.66602L3.33301 13.9993'
        stroke='white'
        strokeWidth='1.3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default Gallery
